export default "__VITE_ASSET__daf82454__$_?component__"